var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChromeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1433 1.25253C10.1433 1.25253 15.3009 1.0219 18.0353 6.18757H9.70442C9.70442 6.18757 8.13221 6.13708 6.7892 8.0376C6.4034 8.83529 5.98871 9.65701 6.45408 11.2764C5.7837 10.1447 2.89504 5.13285 2.89504 5.13285C2.89504 5.13285 4.93254 1.45674 10.1432 1.25253H10.1433Z",
    fill: "#EF3F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7676 14.3661C17.7676 14.3661 15.3877 18.9335 9.53323 18.7076C10.2566 17.4606 13.6998 11.5189 13.6998 11.5189C13.6998 11.5189 14.5317 10.1878 13.5503 8.07834C13.0511 7.34553 12.5424 6.57909 10.9028 6.17059C12.2218 6.15865 18.0208 6.17059 18.0208 6.17059C18.0208 6.17059 20.1933 9.7674 17.7676 14.3661Z",
    fill: "#FCD900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55496 14.4021C2.55496 14.4021 -0.225229 10.0653 2.89974 5.12549C3.62072 6.37249 7.06396 12.3142 7.06396 12.3142C7.06396 12.3142 7.80665 13.6982 10.1287 13.9047C11.0136 13.8399 11.9347 13.7846 13.1115 12.5761C12.4627 13.7198 9.5523 18.7173 9.5523 18.7173C9.5523 18.7173 5.33748 18.7942 2.55489 14.4021H2.55496Z",
    fill: "#61BC5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53082 18.7508L10.7027 13.8783C10.7027 13.8783 11.9903 13.7773 13.0706 12.5977C12.4002 13.7726 9.53082 18.7508 9.53082 18.7508Z",
    fill: "#5AB055"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21776 10.0556C6.21776 7.9077 7.96595 6.16577 10.1216 6.16577C12.2772 6.16577 14.0254 7.9077 14.0254 10.0556C14.0254 12.2036 12.2772 13.9454 10.1216 13.9454C7.96595 13.9431 6.21776 12.2036 6.21776 10.0556Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87118 10.0557C6.87118 8.26812 8.3252 6.81689 10.1216 6.81689C11.9156 6.81689 13.372 8.26573 13.372 10.0557C13.372 11.8433 11.918 13.2945 10.1216 13.2945C8.3276 13.2945 6.87118 11.8433 6.87118 10.0557Z",
    fill: "url(#paint0_linear_8496_110964)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0184 6.17314L13.1935 7.5835C13.1935 7.5835 12.4653 6.51907 10.9004 6.17314C12.2579 6.1659 18.0184 6.17314 18.0184 6.17314Z",
    fill: "#EACA05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36006 11.0986C5.68242 9.92852 2.89504 5.13281 2.89504 5.13281L6.46852 8.6551C6.46852 8.6551 6.10197 9.40716 6.23947 10.4835L6.35999 11.0986H6.36006Z",
    fill: "#DF3A32"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8496_110964",
    x1: 10.1214,
    y1: 6.86263,
    x2: 10.1214,
    y2: 13.0995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1072BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeIcon);
export default __webpack_public_path__ + "static/media/chrome-icon.6e68955b636fb92aeba722263baffd58.svg";
export { ForwardRef as ReactComponent };